import { render } from "./VoiceRecorder.vue?vue&type=template&id=39f2a59b&scoped=true"
import script from "./VoiceRecorder.vue?vue&type=script&lang=js"
export * from "./VoiceRecorder.vue?vue&type=script&lang=js"

import "./VoiceRecorder.vue?vue&type=style&index=0&id=39f2a59b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f2a59b"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/VoiceRecorder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39f2a59b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39f2a59b', __exports__)) {
    api.reload('39f2a59b', __exports__)
  }
  
  module.hot.accept("./VoiceRecorder.vue?vue&type=template&id=39f2a59b&scoped=true", () => {
    api.rerender('39f2a59b', render)
  })

}


export default __exports__